// Typelizer digest cdf8709ca00a9a330a4ba7c3bd153ff0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/sales_documents/:sales_document_id/acceptance */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/acceptance', params, options),
    method: 'post',
  }),
}
